<template>
  <div class="form-field" :class="{ 'has-error': v.$error }">
    <div class="form-checkbox">
      <label :for="name">
        <div class="checkbox-label"><slot></slot><span v-if="v">*</span></div>
        <div class="checkbox">
          <input
            :id="name"
            :name="name"
            :data-cy="name"
            type="checkbox"
            :checked="$attrs.value"
            @change="$emit('input', $event.target.checked)"
          />
          <div></div>
        </div>
      </label>
    </div>

    <div class="errors">
      <div v-if="v && !v.sameAs">{{ $t("field_is_required") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    v: {
      type: [Boolean, Object],
      default: () => {
        return false;
      }
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "text"
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
label {
  display: flex;
  flex-direction: row-reverse;
}
.checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}

.checkbox-label {
  cursor: pointer;
  color: $white-60;
  font-size: 16px;
  span {
    color: red;
  }

  a {
    text-decoration: underline;
  }

  &:hover {
    ~ .checkbox > div {
      background-color: $white-20;
      background-image: url("/png/check-white.png");
      background-size: 14px;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}

.checkbox input[type="checkbox"],
.checkbox input[type="radio"] {
  opacity: 0;
  visibility: hidden;
  display: none;
}

.checkbox > div {
  background-color: transparent;
  border: 2px solid $white-40;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;

  &:hover {
    background-color: $white-20;
    background-image: url("~@/assets/img/png/check-white.png");
    background-size: 14px;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.checkbox input[type="radio"]:checked ~ div,
.checkbox input[type="checkbox"]:checked ~ div,
.checkbox--checked > div {
  border-color: $yellow;
  background-color: $yellow;
  background-image: url("~@/assets/img/png/check-black.png");
  background-size: 14px;
  background-position: center;
  background-repeat: no-repeat;
}

.form-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.errors > div {
  color: #ff0000;
  font-size: 11px;
  margin-top: 10px;
  display: none;
}

.has-error {
  input {
    border-color: #ff0000;
  }
  .errors > div {
    display: block;
  }
}

.form-checkbox {
  display: flex;
  align-items: center;

  label {
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }
}

@media screen and (max-height: 800px) {
  .form-field {
    margin-bottom: 15px;
  }
}
</style>
